import request from '@/plugin/axios'
export function getAgentPagedList (query) {
  return request({
    url: '/moblieapp/agentPagedlist',
    method: 'post',
    params: query
  })
}
export function getAgentPagedListYys (query) {
  return request({
    url: '/moblieapp/agentPagedlistYys',
    method: 'post',
    params: query
  })
}

export function getAgentPagedListDcsj (query) {
  return request({
    url: '/moblieapp/agentPagedlistDcsj',
    method: 'post',
    params: query
  })
}
export function saveExplosivegood (data) {
  return request({
    url: '/moblieapp/saveExplosivegood',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}
export function myIntegralorderlist (query) {
  return request({
    url: '/moblieapp/MyIntegralorderlistpc',
    method: 'post',
    params: query
  })
}

export function qrIntegral (data) {
  return request({
    url: '/moblieapp/integralQr',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '操作成功',
        type: 'success'
      }
    }
  })
}

export function getIntegralGoodsSum (data) {
  return request({
    url: '/moblieapp/getIntegralGoodsSum',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getOneIntegral (data) {
  return request({
    url: '/moblieapp/getOneIntegral',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}
export function getTwoIntegral (data) {
  return request({
    url: '/moblieapp/getTwoIntegral',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}
export function saveIntegralGoods (data) {
  return request({
    url: '/moblieapp/IntegralGoodsSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}
export function getIntegralGoogsPagedList (query) {
  return request({
    url: '/moblieapp/integralgoodsPagedlist',
    method: 'post',
    params: query
  })
}
export function updateIntegralGoodtypes (data) {
  return request({
    url: '/moblieapp/updateIntegralGoodtypes',
    method: 'post',
    data: data
  })
}
export function delIntegralGoodss (ids) {
  return request({
    url: '/moblieapp/batchdelIntegralGoods',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}
export function saveDltype (data) {
  return request({
    url: '/moblieapp/DltypeSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function delIntegralGoods (data) {
  return request({
    url: '/moblieapp/delIntegralGoods',
    method: 'post',
    data: data
  })
}
export function batchUpperYearGoods (ids) {
  return request({
    url: '/moblieapp/batchUpperYearGoods',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '上架成功',
        type: 'success'
      }
    }
  })
}

export function batchLowerYearGoods (ids) {
  return request({
    url: '/moblieapp/batchLowerYearGoods',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '下架成功',
        type: 'success'
      }
    }
  })
}

export function IntegralordeExpress (data) {
  return request({
    url: '/moblieapp/IntegralordeExpress',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function delIntegral (data) {
  return request({
    url: '/moblieapp/integralDel',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '操作成功',
        type: 'success'
      }
    }
  })
}

export function getGoogsPagedList (query) {
  return request({
    url: '/moblieapp/goodsPagedlist',
    method: 'post',
    params: query
  })
}

export function goodsIntegralPagedlist (query) {
  return request({
    url: '/moblieapp/goodsIntegralPagedlist',
    method: 'post',
    params: query
  })
}

export function saveVideogood (data) {
  return request({
    url: '/moblieapp/saveVideogood',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function goodsVideoPagedlist (query) {
  return request({
    url: '/moblieapp/goodsVideoPagedlist',
    method: 'post',
    params: query
  })
}

export function getAdvertPagedList (query) {
  return request({
    url: '/moblieapp/advertPagedList',
    method: 'post',
    params: query
  })
}

export function getAdvertSmallPagedList (query) {
  return request({
    url: '/moblieapp/advertSmallPagedList',
    method: 'post',
    params: query
  })
}

export function getAdvertImgPagedList (query) {
  return request({
    url: '/moblieapp/advertImgPagedList',
    method: 'post',
    params: query
  })
}

export function getAdvertJlPagedList (query) {
  return request({
    url: '/moblieapp/advertJlPagedList',
    method: 'post',
    params: query
  })
}

export function getAdvertSelPagedList (query) {
  return request({
    url: '/moblieapp/advertSelPagedList',
    method: 'post',
    params: query
  })
}

export function getIsholiday (data) {
  return request({
    url: '/moblieapp/getIsholiday',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getIsInter (data) {
  return request({
    url: '/moblieapp/getIsInter',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function disCouponPagedList (query) {
  return request({
    url: '/moblieapp/disCouponPagedList',
    method: 'post',
    params: query
  })
}

export function redEnvelopesPagedList (query) {
  return request({
    url: '/moblieapp/redEnvelopesPagedList',
    method: 'post',
    params: query
  })
}

export function getEncouragePagedList (query) {
  return request({
    url: '/moblieapp/encouragePagedList',
    method: 'post',
    params: query
  })
}

export function getAgentdeployPagedList (query) {
  return request({
    url: '/moblieapp/agentdeployPagedList',
    method: 'post',
    params: query
  })
}

export function getAgentStorePagedList (query) {
  return request({
    url: '/moblieapp/agentStorePagedList',
    method: 'post',
    params: query
  })
}
export function getDepositPagedlist (query) {
  return request({
    url: '/moblieapp/depositPagedlist',
    method: 'post',
    params: query
  })
}

export function getPaymentcodePagedlist (query) {
  return request({
    url: '/moblieapp/paymentcodePagedlist',
    method: 'post',
    params: query
  })
}

export function getMobileOrderDdglPagelist (query) {
  return request({
    url: '/moblieapp/mobileOrderDdglPagelist',
    method: 'post',
    params: query
  })
}

export function getGoodOrderlist (query) {
  return request({
    url: '/moblieapp/goodOrderlist',
    method: 'post',
    params: query
  })
}

export function getMoblieOrderSbPagedList (query) {
  return request({
    url: '/moblieapp/mobileOrderSbPagedlist',
    method: 'post',
    params: query
  })
}

export function getAgentStoreSpeakerPagelist (query) {
  return request({
    url: '/moblieapp/agentStoreSpeakerPagelist',
    method: 'post',
    params: query
  })
}

export function getAgentStoreRulePagelist (query) {
  return request({
    url: '/moblieapp/agentStoreRulePagelist',
    method: 'post',
    params: query
  })
}

export function getAgentStorePrintingPagelist (query) {
  return request({
    url: '/moblieapp/agentStorePrintingPagelist',
    method: 'post',
    params: query
  })
}

export function getAdvertExposurePagedList (query) {
  return request({
    url: '/moblieapp/advertExposurePagedlist',
    method: 'post',
    params: query
  })
}

export function getGoodsTypePageList (query) {
  return request({
    url: '/moblieapp/goodsTypePageList',
    method: 'post',
    params: query
  })
}

export function getRuletypePageList (query) {
  return request({
    url: '/moblieapp/ruletypePageList',
    method: 'post',
    params: query
  })
}

export function getEquipmentPagedList (query) {
  return request({
    url: '/moblieapp/equipmentPagedList',
    method: 'post',
    params: query
  })
}

export function getAgentReplyPagedList (query) {
  return request({
    url: '/moblieapp/agentReplyPagedList',
    method: 'post',
    params: query
  })
}

export function getMobileOrderPagedlist (query) {
  return request({
    url: '/moblieapp/mobileOrderPagedlist',
    method: 'post',
    params: query
  })
}

export function getMobileOrderPagedlistSettlement (query) {
  return request({
    url: '/moblieapp/mobileOrderPagedlistSettlement',
    method: 'post',
    params: query
  })
}

export function getMobileOrderPagedlistSettlementBt (query) {
  return request({
    url: '/moblieapp/mobileOrderPagedlistSettlementBt',
    method: 'post',
    params: query
  })
}

export function getMobileOrderPagedlistSettlementXq (query) {
  return request({
    url: '/moblieapp/mobileOrderPagedlistSettlementXq',
    method: 'post',
    params: query
  })
}

export function getMobileOrderPagedlistXq (query) {
  return request({
    url: '/moblieapp/mobileOrderPagedlistXq',
    method: 'post',
    params: query
  })
}

export function getMobileOrderPagelistJymx (query) {
  return request({
    url: '/moblieapp/mobileOrderPagelistJymx',
    method: 'post',
    params: query
  })
}

export function getMobileOrderPagelistJymxBt (query) {
  return request({
    url: '/moblieapp/mobileOrderPagelistJymxBt',
    method: 'post',
    params: query
  })
}

export function getMobileOrderPageJymxList (query) {
  return request({
    url: '/moblieapp/mobileOrderPageJymxList',
    method: 'post',
    params: query
  })
}

export function getProvcd (data) {
  return request({
    url: '/moblieapp/getProvcd',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getProvcdYh (data) {
  return request({
    url: '/moblieapp/getProvcdYh',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStoreagent (data) {
  return request({
    url: '/moblieapp/getStoreagent',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStoreUser (data) {
  return request({
    url: '/moblieapp/getStoreUser',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStoreQrcode (data) {
  return request({
    url: '/moblieapp/getStoreQrcode',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getGoodtyps (data) {
  return request({
    url: '/moblieapp/getGoodtyps',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getRuletyps (data) {
  return request({
    url: '/moblieapp/getRuletyps',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getPassword (data) {
  return request({
    url: '/moblieapp/getPassword',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function updatePhotoIdcards (data) {
  return request({
    url: '/moblieapp/updatePhotoIdcards',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getOneagent (data) {
  return request({
    url: '/moblieapp/getOneagent',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}
export function getPerfectAgent (data) {
  return request({
    url: '/moblieapp/getPerfectAgent',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getPhotoIdcards (data) {
  return request({
    url: '/moblieapp/getPhotoIdcards',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getAgentXq (data) {
  return request({
    url: '/moblieapp/getAgentXq',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getRakebackXq (data) {
  return request({
    url: '/moblieapp/getRakebackXq',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getExplosiveXq (data) {
  return request({
    url: '/moblieapp/getExplosiveXq',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function AgentSaveConfigure (data) {
  return request({
    url: '/moblieapp/AgentSaveConfigure',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    },
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function ServiceSaveConfigure (data) {
  return request({
    url: '/moblieapp/ServiceSaveConfigure',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    },
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function getConfigureAgent (data) {
  return request({
    url: '/moblieapp/getConfigureAgent',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsOrder (data) {
  return request({
    url: '/moblieapp/getStatisticsOrder',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsJymx (data) {
  return request({
    url: '/moblieapp/getStatisticsJymx',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsListJymx (data) {
  return request({
    url: '/moblieapp/getStatisticsListJymx',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getGoodsSum (data) {
  return request({
    url: '/moblieapp/getGoodsSum',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsOrderYj (data) {
  return request({
    url: '/moblieapp/getStatisticsOrderYj',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsOrderBt (data) {
  return request({
    url: '/moblieapp/getStatisticsOrderBt',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsOrderListYj (data) {
  return request({
    url: '/moblieapp/getStatisticsOrderListYj',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsOrderJs (data) {
  return request({
    url: '/moblieapp/getStatisticsOrderJs',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsOrderJsBt (data) {
  return request({
    url: '/moblieapp/getStatisticsOrderJsBt',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsOrderListJs (data) {
  return request({
    url: '/moblieapp/getStatisticsOrderListJs',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}
export function getStatisticsHome (data) {
  return request({
    url: '/moblieapp/getStatisticsHome',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsHomesjtj (data) {
  return request({
    url: '/moblieapp/getStatisticsHomesjtj',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsHomePay (data) {
  return request({
    url: '/moblieapp/getStatisticsHomePay',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsHomedl (data) {
  return request({
    url: '/moblieapp/getStatisticsHomedl',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsOrderbb (data) {
  return request({
    url: '/moblieapp/getStatisticsOrderbb',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsOrdertk (data) {
  return request({
    url: '/moblieapp/getStatisticsOrdertk',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsOrderzffs (data) {
  return request({
    url: '/moblieapp/getStatisticsOrderzffs',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getStatisticsOrdercj (data) {
  return request({
    url: '/moblieapp/getStatisticsOrdercj',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getConfigureService (data) {
  return request({
    url: '/moblieapp/getConfigureService',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getShopsType (data) {
  return request({
    url: '/moblieapp/getShopsType',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}
export function editRoleUser (data) {
  return request({
    url: '/moblieapp/editroleuser',
    method: 'post',
    data: data
  })
}
export function saveAgent (data) {
  return request({
    url: '/moblieapp/AgentSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveSjrr (data) {
  return request({
    url: '/moblieapp/SjrrSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveAgentCity (data) {
  return request({
    url: '/moblieapp/AgentSaveCity',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveAgentStore (data) {
  return request({
    url: '/moblieapp/AgentStoreSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveAgentStoreSpeaker (data) {
  return request({
    url: '/moblieapp/AgentStoreSaveSpeaker',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveAgentStoreRule (data) {
  return request({
    url: '/moblieapp/AgentStoreSaveRule',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveAgentStorePrinting (data) {
  return request({
    url: '/moblieapp/AgentStoreSavePrinting',
    method: 'post',
    data: data
  })
}

export function savePoster (data) {
  return request({
    url: '/moblieapp/PosterSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveSmallPoster (data) {
  return request({
    url: '/moblieapp/SmallPosterSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveImgPoster (data) {
  return request({
    url: '/moblieapp/ImgPosterSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveJlPoster (data) {
  return request({
    url: '/moblieapp/JlPosterSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveSelPoster (data) {
  return request({
    url: '/moblieapp/SelPosterSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveCouponRakeback (data) {
  return request({
    url: '/moblieapp/saveCouponRakeback',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveAccountGlj (data) {
  return request({
    url: '/moblieapp/saveAccountGlj',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveEncourage (data) {
  return request({
    url: '/moblieapp/EncourageSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveAgentdeploy (data) {
  return request({
    url: '/moblieapp/AgentdeploySave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveMyshops (data) {
  return request({
    url: '/moblieapp/MyshopsSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveRakeback (data) {
  return request({
    url: '/moblieapp/RakebackSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveExplosive (data) {
  return request({
    url: '/moblieapp/ExplosiveSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function updateRelation (data) {
  return request({
    url: '/moblieapp/updateRelation',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function updateRelationBatch (data) {
  return request({
    url: '/moblieapp/updateRelationBatch',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function saveEquipment (data) {
  return request({
    url: '/moblieapp/EquipmentSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveAgentReply (data) {
  return request({
    url: '/moblieapp/AgentReplySave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveDepositgl (data) {
  return request({
    url: '/moblieapp/DepositglSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveAgentJjOne (data) {
  return request({
    url: '/moblieapp/AgentSaveJjOne',
    method: 'post',
    data: data
  })
}

export function saveAgentNewJjOne (data) {
  return request({
    url: '/moblieapp/AgentSaveNewJjOne',
    method: 'post',
    data: data
  })
}

export function saveAgentJjTwo (data) {
  return request({
    url: '/moblieapp/AgentSaveJjTwo',
    method: 'post',
    data: data
  })
}

export function saveAgentPz (data) {
  return request({
    url: '/moblieapp/AgentSavePz',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    },
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}
export function saveAgentNewJjTwo (data) {
  return request({
    url: '/moblieapp/AgentSaveNewJjTwo',
    method: 'post',
    data: data
  })
}

export function saveAgentJjThree (data) {
  return request({
    url: '/moblieapp/AgentSaveJjThree',
    method: 'post',
    data: data
  })
}

export function saveAgentNewJjThree (data) {
  return request({
    url: '/moblieapp/AgentSaveNewJjThree',
    method: 'post',
    data: data
  })
}

export function saveAgentJjFour (data) {
  return request({
    url: '/moblieapp/AgentSaveJjFour',
    method: 'post',
    data: data
  })
}

export function saveShareAgent (data) {
  return request({
    url: '/moblieapp/ShareAgentSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function getShareAgent (data) {
  return request({
    url: '/moblieapp/getShareAgent',
    method: 'post',
    data: data
  })
}

export function savePagentid (data) {
  return request({
    url: '/moblieapp/PagentidSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveRedAmt (data) {
  return request({
    url: '/moblieapp/RedAmtSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveGljAmt (data) {
  return request({
    url: '/moblieapp/GljAmtSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveGoodsType (data) {
  return request({
    url: '/moblieapp/GoodsTypeSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveRuleType (data) {
  return request({
    url: '/moblieapp/RuleTypeSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveGoods (data) {
  return request({
    url: '/moblieapp/GoodsSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function savePaymentcode (data) {
  return request({
    url: '/moblieapp/PaymentcodeSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function savePagentidDltype (data) {
  return request({
    url: '/moblieapp/DltypePagentidSave',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function delAgent (data) {
  return request({
    url: '/moblieapp/agentDel',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '操作成功',
        type: 'success'
      }
    }
  })
}

export function delSjrr (data) {
  return request({
    url: '/moblieapp/sjrrDel',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '操作成功',
        type: 'success'
      }
    }
  })
}

export function delAgentDl (data) {
  return request({
    url: '/moblieapp/agentDelDl',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '操作成功',
        type: 'success'
      }
    }
  })
}

export function wxjj (data) {
  return request({
    url: '/moblieapp/wxjj',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '操作成功',
        type: 'success'
      }
    }
  })
}

export function lswxjj (data) {
  return request({
    url: '/moblieapp/lswxjj',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '操作成功',
        type: 'success'
      }
    }
  })
}

export function delus (data) {
  return request({
    url: '/moblieapp/delus',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '操作成功',
        type: 'success'
      }
    }
  })
}

export function tpwxus (data) {
  return request({
    url: '/moblieapp/tpwxus',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '操作成功',
        type: 'success'
      }
    }
  })
}

export function delDeposit (data) {
  return request({
    url: '/moblieapp/delDeposit',
    method: 'post',
    data: data
  })
}

export function delAgentStoreSpeaker (data) {
  return request({
    url: '/moblieapp/delAgentStoreSpeaker',
    method: 'post',
    data: data
  })
}

export function delAgentStoreRule (data) {
  return request({
    url: '/moblieapp/delAgentStoreRule',
    method: 'post',
    data: data
  })
}

export function delAgentStorePrinting (data) {
  return request({
    url: '/moblieapp/delAgentStorePrinting',
    method: 'post',
    data: data
  })
}

export function delPaymentcode (data) {
  return request({
    url: '/moblieapp/delPaymentcode',
    method: 'post',
    data: data
  })
}

export function delGoodsType (data) {
  return request({
    url: '/moblieapp/delGoodsType',
    method: 'post',
    data: data
  })
}

export function delRuleType (data) {
  return request({
    url: '/moblieapp/delRuleType',
    method: 'post',
    data: data
  })
}

export function delGoods (data) {
  return request({
    url: '/moblieapp/delGoods',
    method: 'post',
    data: data
  })
}

export function delGoodsTypes (ids) {
  return request({
    url: '/moblieapp/batchdelGoodsTypes',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function delRuleTypes (ids) {
  return request({
    url: '/moblieapp/batchdelRuleTypes',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function delGoodss (ids) {
  return request({
    url: '/moblieapp/batchdelGoods',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function delAdvert (data) {
  return request({
    url: '/moblieapp/delAdvert',
    method: 'post',
    data: data
  })
}

export function delAdvertSmall (data) {
  return request({
    url: '/moblieapp/delAdvertSmall',
    method: 'post',
    data: data
  })
}

export function delAdvertImg (data) {
  return request({
    url: '/moblieapp/delAdvertImg',
    method: 'post',
    data: data
  })
}

export function delAdvertJl (data) {
  return request({
    url: '/moblieapp/delAdvertJl',
    method: 'post',
    data: data
  })
}

export function delAdvertSel (data) {
  return request({
    url: '/moblieapp/delAdvertSel',
    method: 'post',
    data: data
  })
}

export function delCouponRakeback (data) {
  return request({
    url: '/moblieapp/delCouponRakeback',
    method: 'post',
    data: data
  })
}

export function delAgentdeploy (data) {
  return request({
    url: '/moblieapp/delAgentdeploy',
    method: 'post',
    data: data
  })
}

export function updateAdvert (data) {
  return request({
    url: '/moblieapp/updateAdvert',
    method: 'post',
    data: data
  })
}
export function updateAdvertSmall (data) {
  return request({
    url: '/moblieapp/updateAdvertSmall',
    method: 'post',
    data: data
  })
}

export function updateAdvertImg (data) {
  return request({
    url: '/moblieapp/updateAdvertImg',
    method: 'post',
    data: data
  })
}

export function updateAdvertJl (data) {
  return request({
    url: '/moblieapp/updateAdvertJl',
    method: 'post',
    data: data
  })
}

export function updateAdvertSel (data) {
  return request({
    url: '/moblieapp/updateAdvertSel',
    method: 'post',
    data: data
  })
}

export function batchAdvert (ids) {
  return request({
    url: '/moblieapp/batchAdvert',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function batchAdvertSmall (ids) {
  return request({
    url: '/moblieapp/batchAdvertSmall',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function batchAdvertImg (ids) {
  return request({
    url: '/moblieapp/updateAdvertImg',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function batchAdvertJl (ids) {
  return request({
    url: '/moblieapp/batchAdvertJl',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function batchAdvertSel (ids) {
  return request({
    url: '/moblieapp/batchAdvertSel',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function batchCouponRakeback (ids) {
  return request({
    url: '/moblieapp/batchCouponRakeback',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function batchAgentdeploy (ids) {
  return request({
    url: '/moblieapp/batchAgentdeploy',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function batchUpperGoods (ids) {
  return request({
    url: '/moblieapp/batchUpperGoods',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '上架成功',
        type: 'success'
      }
    }
  })
}

export function batchLowerGoods (ids) {
  return request({
    url: '/moblieapp/batchLowerGoods',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '下架成功',
        type: 'success'
      }
    }
  })
}

export function updateGoodtypes (data) {
  return request({
    url: '/moblieapp/updateGoodtypes',
    method: 'post',
    data: data
  })
}

export function resetAgent (data) {
  return request({
    url: '/moblieapp/agentReset',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '操作成功',
        type: 'success'
      }
    }
  })
}
export function delUsers (ids) {
  return request({
    url: '/user/batchdel',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}
